import {documentUtils} from 'front-onceforall-core';

import config from '../../../config';

import {SIGN_PERMISSION} from '../../utils/constant';
import {openOrSaveFile} from '../../utils/http';
import {getDocumentName} from '../../utils/document';
import {pathDocumentExamples} from '../../utils/path';

import documentService from '../../services/document/DocumentService';
import authenticationService from '../../services/authentication/AuthenticationService';
import {recordGAEvent} from '../../utils/analytics';

export function getDossierName(dossier) {
  if (dossier === 'BUSINESS') {
    return 'dossier.labels.BUSINESS.ALL';
  }

  return `dossier.labels.${dossier}`;
}

export function processDocuments(docs = []) {
  let documents = docs.map(documentUtils.computeHasAnotherOccurrenceInSameDossier(docs));
  documents = documentUtils.groupDocumentsByCorrelationId(documents);
  documents = documentUtils.removeArchivedCorrelationIds(documents);
  documents = documentUtils.groupAndOrderDocumentVersionsByDossierType(documents);
  return documents;
}

export function handleDocumentOpen(document) {
  window.location.href = `${config.backOfficeUrl}/documents/${document.uid}`;
}

export function handleDocumentExampleOpen(event, name) {
  event.preventDefault();
  event.stopPropagation();
  window.open(`${pathDocumentExamples + getDocumentName(name)}.pdf`);
}

export function handleDocumentFileOpen(document, excel) {
  if (document.unpublished) {
    recordGAEvent('SUPPLIER_DOCUMENT', 'Download document');
  } else {
    recordGAEvent('SUPPLIER_DOCUMENT', 'Download current document');
  }
  authenticationService.authRedirect(documentService.getFileUrl(document.uid, excel))
    .then(authUrl => openOrSaveFile(authUrl));
}

export function handleDocumentProofFileOpen(document) {
  authenticationService.authRedirect(documentService.getFileProofUrl(document.uid))
    .then(authUrl => openOrSaveFile(authUrl));
}

export function getDocumentPermissions(isDepositor) {
  const isManager = authenticationService.roles().isManager();
  const isBackOffice = authenticationService.roles().isBackOffice();

  return {
    canEditAdditionalDesignation: isManager && isDepositor,
    canSeeSignAction: true,
    canSign: isDepositor && authenticationService.roles().hasPermission(SIGN_PERMISSION),
    canUpload: isManager,
    canUploadByMandate: isBackOffice,
    canDownload: isDepositor,
    canDownloadExcel: isDepositor,
    canDownloadWithInvalidState: isDepositor,
    canDownloadProof: isDepositor,
    canDuplicate: isManager && isDepositor,
    canDelete: isManager && isDepositor,
    isBackOffice,
    canSeePayrollRatio: true
  };
}

export function getTimelineVersions(organisationId, documentVersions) {
  return documentService.getAllDocumentValidVersions(organisationId, documentVersions[0].correlationId);
}
